import { _ } from "../../../core/polyglot/polyglot.js";
import { select } from "../../../core/elements/index.js";
import { Widget } from "@foretagsplatsen/widgetjs";
import KeyFigure from "../../../models/keyFigure/KeyFigure.js";
import keyFigureValueWidget from "../shared/keyFigureValueWidget.js";

/**
 * `KeyFigureValueTypeEditorWidget` renders a `keyFigureValueWidget` for
 * displaying the result of a keyFigure, with an option to edit the value type
 * of the keyfigure.
 */
export default class KeyFigureValueTypeEditorWidget extends Widget {
	constructor({ keyFigure, keyFigureResult } = {}) {
		super(...arguments);

		this._keyFigure = keyFigure;
		this._keyFigureResult = keyFigureResult;

		this.keyFigureValueTypeChanged = this._events.createEvent();

		this._keyFigureValue = keyFigureValueWidget();
	}

	setKeyFigure(keyFigure) {
		this._keyFigure = keyFigure;
		this.update();
	}

	setResult(result) {
		this._keyFigureValue.setResult(result);
	}

	renderContentOn(html) {
		html.h2(
			{ klass: "keyfigure-result" },
			_("Result"),
			this._renderValueTypeDropdownOn.bind(this),
		);

		html.render(this._keyFigureValue);
	}

	_renderValueTypeDropdownOn(html) {
		if (!this._keyFigure) {
			return;
		}

		html.div(
			{ klass: "value-type-editor" },
			select({
				ref: (ref) => ref.setAttribute("name", "value-type"),
				items: KeyFigure.valueTypes(),
				selected: this._keyFigure.getValueType(),
				onChange: (value) => {
					this.keyFigureValueTypeChanged.trigger(value);
				},
			}),
		);
	}
}
